const imageOption = ({latest_band_media, ordering}) => {

  const limited = latest_band_media && latest_band_media.length > 0 && latest_band_media.slice(0, 3);
    if (!limited) return null;

    const mediaSlides = [];

    limited.forEach((m, index) => {
      const copy = {
        0: {
          "order": ordering[`media_${index + 1}`],
          "name": "media",
          "tracking": `media_image_${m.date}`,
          "colorOption": 1,
          "dataPoints": {
            "title": "Where band mates become real mates",
            "photo_url": m.photo_url,
            "date": m.date,
            "photo_media_submission_id": m.photo_media_submission_id,
          },
        },
        1: {
          "order": ordering[`media_${index + 1}`],
          "name": "media",
          "tracking": `media_image_${m.date}`,
          "colorOption": 5,
          "dataPoints": {
            "title": "Working hard at band practice!",
            "photo_url": m.photo_url,
            "date": m.date,
            "photo_media_submission_id": m.photo_media_submission_id,
          }
        },
        2: {
          "order": ordering[`media_${index + 1}`],
          "name": "media",
          "tracking": `media_image_${m.date}`,
          "colorOption": 5,
          "dataPoints": {
            "title": "Future rockstars in the making!",
            "photo_url": m.photo_url,
            "date": m.date,
            "photo_media_submission_id": m.photo_media_submission_id,
          }
        }
      }


      if (m.media_type === 'photo') {
        const mediaData = {
          "order": ordering[`media_${index + 1}`],
          "name": "media",
          "tracking": copy[index].tracking,
          "colorOption": copy[index].colorOption,
          "dataPoints": copy[index].dataPoints
        }
        mediaSlides.push(mediaData)
      }

      return null;
    })
    return mediaSlides.length ? mediaSlides : null;
}

export default imageOption;

